import { ActionTypes } from "../constants/actionTypes";

const initialState = {
    admincompetitors: { data: null, requestInProgress: false, error: null },
    adminsingleclicktypes: { data: null, requestInProgress: false, error: null }
};

export function adminCompetitiveDash(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ADMIN_DASHBOARD_TABLE_REQUEST:
            return { ...state, admincompetitors: { requestInProgress: true } };
        case ActionTypes.ADMIN_DASHBOARD_TABLE_SUCCESS:
            return { ...state, admincompetitors: { data: action.admincompetitors, requestInProgress: false } };
        case ActionTypes.ADMIN_DASHBOARD_TABLE_FAILURE:
            return { ...state, admincompetitors: { requestInProgress: false, error: action.error } };
        // case ActionTypes.SINGLE_CLICK_TYPE_REQUEST:
        //     return { ...state, singleclicktypes: { requestInProgress: true } };
        // case ActionTypes.SINGLE_CLICK_TYPE_SUCCESS:
        //     return { ...state, singleclicktypes: { data: action.singleclicktypes, requestInProgress: false } };
        // case ActionTypes.SINGLE_CLICK_TYPE_FAILURE:
        //     return { ...state, singleclicktypes: { requestInProgress: false, error: action.error } };
        default:
            return state;
    }
}